package com.jingfangpai.diagnosisSetting.model

import com.jingfangpai.common.orm.mapping.DiagnosisSetting
import kotlinx.serialization.Serializable

@Serializable
class DiagnosisSettingDto: DiagnosisSetting() {
    var signSymptomSettings:Array<SignSymptomSettingDto> = arrayOf()
}